import { useLayers } from '@ais-ui/react-openlayers';
import { NextPortArrivalWithDate } from '@ais-ui/api';
import React, { useMemo } from 'react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiPath } from 'react-icons/pi';
import useRouteFetchAndDraw from './useRouteFetchAndDraw';

interface RouteButtonProps {
  mmsi: string;
  shipName: string;
  nextport: NextPortArrivalWithDate;
  portName: string | undefined;
}

export const RouteButton = ({
  mmsi,
  shipName,
  nextport,
  portName,
}: RouteButtonProps) => {
  const { doesLayerExist, removeLayerById } = useLayers();

  const routeId = useMemo(() => {
    const numberMmsi = parseInt(mmsi);
    const locode = nextport?.locode ? nextport.locode : '';

    return `${numberMmsi}-${locode}`;
  }, [mmsi, nextport]);

  const { onFetchRoute, isCalculatingRoute } = useRouteFetchAndDraw({
    mmsi: mmsi,
    locode: nextport?.locode ? nextport.locode : '',
    shipName,
    portName,
  });

  const isRouteShown = doesLayerExist(routeId);

  const onRemove = () => {
    removeLayerById(routeId);
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          onClick={isRouteShown ? onRemove : onFetchRoute}
          disabled={isCalculatingRoute || !mmsi}
        >
          {isRouteShown ? (
            <PiPath className="h-6 w-6 text-red-500" />
          ) : (
            <PiPath className="h-6 w-6 text-green-500" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>Draw path from vessel to port</TooltipContent>
    </Tooltip>
  );
};
